import { zeroPad } from "./zeroPad";

export const serializeDate = (date: Date): string => {
  const year = zeroPad(date.getFullYear(), 4);
  const month = zeroPad(date.getMonth() + 1, 2);
  const day = zeroPad(date.getDate(), 2);

  return `${year}-${month}-${day}`;
};

export const parseDateRange = (
  dateRange: string | null,
): [Date | undefined, Date | undefined] => {
  if (!dateRange) return [undefined, undefined];
  const [from, to] = dateRange.split("_");
  return [from ? new Date(from) : undefined, to ? new Date(to) : undefined];
};

export const formatDateRange = (
  from: Date | undefined,
  to: Date | undefined,
): string | undefined => {
  if (!from && !to) return undefined;
  return `${from ? serializeDate(from) : ""}_${to ? serializeDate(to) : ""}`;
};
